import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { apiClient } from "./lib/api";
import { captureUtmFromUrl } from "./lib/utm";
import { trackPageView } from "./lib/fbpixel";

/**
 * Reports anonymous page-views to /api/track. One ping per route change,
 * skipped on /admin/* routes (no point tracking the operator).
 * Also captures UTM/click-id params on first arrival and fires a FB Pixel
 * PageView event on each SPA route change (the base PageView fires once on
 * initial HTML load via index.html).
 */
export default function PageTracker() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  // Capture UTM params once on first render (covers reloads on any route)
  useEffect(() => { captureUtmFromUrl(); }, []);

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const ref = document.referrer || "";
    apiClient.post("/track", {
      path: pathname,
      ref,
      lang: i18n.language?.split("-")[0] || "",
    }).catch(() => {});
    trackPageView();
  }, [pathname, i18n.language]);

  return null;
}
